import { render, staticRenderFns } from "./ScreenTranslucenciaNucalPerfilCervicalDopplerMorfologica1Trimestre.vue?vue&type=template&id=22c3ee81&scoped=true&"
import script from "./ScreenTranslucenciaNucalPerfilCervicalDopplerMorfologica1Trimestre.vue?vue&type=script&lang=js&"
export * from "./ScreenTranslucenciaNucalPerfilCervicalDopplerMorfologica1Trimestre.vue?vue&type=script&lang=js&"
import style0 from "./ScreenTranslucenciaNucalPerfilCervicalDopplerMorfologica1Trimestre.vue?vue&type=style&index=0&id=22c3ee81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c3ee81",
  null
  
)

export default component.exports